import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import { AuthProvider } from '../auth/AuthProvider';
import { DialogProvider } from '../components/dialogs';

export function AppProviders({ queryClient, children }: { queryClient: QueryClient; children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <DialogProvider>
        <AuthProvider>{children}</AuthProvider>
      </DialogProvider>
    </QueryClientProvider>
  );
}
